
import { Component, Prop, Watch } from 'vue-property-decorator'
import { SwiperOptions } from 'swiper'
import { TABLET_PORTRAIT_WIDTH, PROP_UNIT_ID, PROP_AMOUNT_ID, PROP_MIN_AMOUNT_ID,
  IMAGE_GROUP_NAME_MAIN,
  IMAGE_GROUP_NAME_DETAILS,
  IMAGE_GROUP_NAME_ADDITIONAL } from '../helpers/constants'
import { findPropWithId } from '../helpers/functions'
import Mixin from '../helpers/mixin'

@Component({})
export default class HeroTextMedia extends Mixin {
  @Prop({ default: 0 }) index = 0
  @Prop({ default: false }) moveBreadcrumbAfterImage: boolean
  @Prop({ default: 1 }) amountOfItems: number
  @Prop({ default: false }) setSticky: boolean
  @Prop() properties: any
  @Prop() allImages: any

  isSticky = false
  elmTop = 0
  isStickyMobile = false
  isSingleSlide = false
  anchorChangeTimeout: number | undefined = undefined

  swiperOptions: SwiperOptions = {
    grabCursor: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    speed: 750,
    pagination: {
      el: `.main-swiper-pagination-js-${this.index}`,
      clickable: true
    }
  }

  mediaSwiperOptions: SwiperOptions = {
    grabCursor: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    speed: 750,
    pagination: {
      el: '.media-swiper-pagination',
      clickable: true
    }
  }

  get amount(): string {
    return findPropWithId(this.properties, PROP_MIN_AMOUNT_ID, '1')
  }

  get salesunit(): string {
    return findPropWithId(this.properties, PROP_AMOUNT_ID, '1')
  }

  get unit(): string {
    return findPropWithId(this.properties, PROP_UNIT_ID, '')
  }

  isSingleSlideCheck() {
    if (!this.allImages) return

    const imagesMainAndDetail = this.allImages.filter((item: any) => item.group == IMAGE_GROUP_NAME_MAIN || item.group == IMAGE_GROUP_NAME_DETAILS || item.group == IMAGE_GROUP_NAME_ADDITIONAL)
    if (imagesMainAndDetail.length === 1) this.isSingleSlide = true
  }

  get hasHeroImage() {
    if (!this.allImages) return false
    const heroImages = this.allImages.filter((item: any) => item.group == IMAGE_GROUP_NAME_MAIN || item.group == IMAGE_GROUP_NAME_DETAILS || item.group == IMAGE_GROUP_NAME_ADDITIONAL);

    return  heroImages.length > 0
  }

  replaceBreadcrumb(): void {
    if (this.amountOfItems > 1) return // do not place breadcrumbs within slider

    const parentEl = this.$el?.parentElement

    if (parentEl && parentEl.firstChild == this.$el && parentEl.tagName.toLowerCase() === 'main') {
      if (this.isPhone) {
        const classSelector = this.moveBreadcrumbAfterImage ? '.text-block': '.media-block'
        const breadcrumbs = document.querySelector('.breadcrumbs')
        const mediaBlock = this.$el.querySelector(classSelector)
        if (breadcrumbs && mediaBlock && mediaBlock.parentNode) {
          breadcrumbs.remove()
          mediaBlock.parentNode.insertBefore(breadcrumbs, mediaBlock) // before because of flex-direction: column-reverse
        }
      } else {
        const breadcrumbs = this.$el.querySelector('.breadcrumbs')
        const mainEl = document.querySelector('main')
        if (breadcrumbs && mainEl && mainEl.parentNode) {
          breadcrumbs.remove()
          mainEl.parentNode.insertBefore(breadcrumbs, mainEl)
        }
      }
    }
  }

  handleScroll(): void {
    const windowScroll = window.scrollY
    const header = document.querySelector<HTMLElement>('.hero-text-media')
    const headerHeight = header ? header.offsetHeight : 0
    const offset = headerHeight

    if (offset <= windowScroll) {
      if (window.innerWidth <= TABLET_PORTRAIT_WIDTH) {
        this.$el.classList.add('sticky-mobile')
        this.isStickyMobile = true

      } else {
        this.$el.classList.add('sticky')
        this.isSticky = true
      }
    } else if (offset > windowScroll) {

      if (window.innerWidth <= TABLET_PORTRAIT_WIDTH) {
        this.$el.classList.remove('sticky-mobile')
        this.isStickyMobile = false

      } else {
        this.$el.classList.remove('sticky')
        this.isSticky = false
      }
    }
  }

  scrollToElement(id: string, heroHeight: number) {
    if (!this.isTabletP && !this.isPhone && (heroHeight > 120)) {
      this.scrollTo(id, 400);
    } else {
      const element = document.getElementById(id);
      let headerOffset = 0;
      if (this.isPhone) {
        headerOffset = 170;
      }
      if (element) {
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }
    }
  }

  scrollTo(id: string, headerOffset: number){
    const element = document.getElementById(id);
    if(element){
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  }

  correctScrolling(ev: any, id: string, timeoutTime: number){
    if (this.anchorChangeTimeout) clearTimeout(this.anchorChangeTimeout)
    const hero = document.querySelector('.hero-text-media')
    const heroHeight = hero ? hero.clientHeight : 0
    this.anchorChangeTimeout = window.setTimeout(() => this.scrollToElement(id, heroHeight), timeoutTime)
  }

  correctScrollingVacancy(ev: any, id: string, timeoutTime: number){
    if (this.anchorChangeTimeout) clearTimeout(this.anchorChangeTimeout)
    const scrollTo = this.scrollTo
    this.anchorChangeTimeout = window.setTimeout(() => {
      scrollTo(id, 150)
    }, timeoutTime)
  }

  checkSticky(): void {
    // on tablet and phone always sticky
    if (window.innerWidth <= TABLET_PORTRAIT_WIDTH) {
      this.$el.classList.add('sticky-mobile')
      this.$el.classList.remove('sticky')
      this.isSticky = true

      this.isStickyMobile = true
    } else {
      this.$el.classList.remove('sticky-mobile')
      this.isSticky = false

      this.isStickyMobile = false
    }
  }

  mounted(): void {
    this.isSingleSlideCheck()
    this.$nextTick(() => this.replaceBreadcrumb())
    this.elmTop = this.$el.getBoundingClientRect().top
    if(this.elmTop < 0) {
      const header = document.querySelector('.sticky-header')
      this.elmTop = header ? header.clientHeight + 50 : 50
    }

    if (this.setSticky) {
      this.handleScroll()
      window.addEventListener('scroll', this.handleScroll)
    }
  }

  @Watch('isPhone', { deep: true })
  onIsPhoneChange() {
    this.replaceBreadcrumb()
    this.checkSticky()
  }

  @Watch('isTabletP', { deep: true })
  onIsTabletP() {
    this.checkSticky()
  }
}
